// extracted by mini-css-extract-plugin
export default {"view":"Main_view__AgjKW"};